import React, { Component, createRef } from 'react';
import { InputSwitch } from 'primereact/inputswitch';
import { Toast } from 'primereact/toast';
import './Profile.css';

const MONITORING_LABELS = { 1: 'MENSAL', 3: 'TRIMESTRAL' };

const titleStyle = {
    fontFamily: 'Archivo Expanded',
    fontWeight: 'bold',
    fontSize: '20px',
    marginBottom: '8px',
};

class NotificationsPanel extends Component {
    constructor(props) {
        super(props);

        const { notifiedCityIds = [] } = props;

        this.state = {
            selectedCityIds: new Set(notifiedCityIds),
            saving: false,
            successMessage: null,
            filter: '',
        };

        this.toast = createRef();
    }

    handleToggle = (cityId, checked) => {
        this.setState(prev => {
            const next = new Set(prev.selectedCityIds);
            if (checked) {
                next.add(cityId);
            } else {
                next.delete(cityId);
            }
            return { selectedCityIds: next };
        });
    };

    handleSave = async () => {
        const { routes, csrfToken } = this.props;
        const { selectedCityIds } = this.state;

        this.setState({ saving: true });

        try {
            await axios.post(
                routes.notificationsPreferences,
                { city_id: [...selectedCityIds] },
                {
                    headers: {
                        'X-XSRF-TOKEN': csrfToken,
                        'X-Requested-With': 'XMLHttpRequest',
                    },
                }
            );

            this.setState({ saving: false });

            this.toast.current && this.toast.current.show({
                severity: 'success',
                summary: 'Notificações salvas',
                detail: 'Suas preferências de notificação foram salvas.',
                life: 3000,
            });
        } catch (err) {
            this.setState({ saving: false });

            this.toast.current && this.toast.current.show({
                severity: 'error',
                summary: 'Erro',
                detail: 'Não foi possível salvar as notificações.',
                life: 3000,
            });
        }
    };

    render() {
        const { cities = [] } = this.props;
        const { selectedCityIds, saving, filter } = this.state;

        const filteredCities = filter.trim()
            ? cities.filter(c =>
                `${c.city} ${c.state}`.toLowerCase().includes(filter.toLowerCase())
              )
            : cities;

        return (
            <div className="profile-card">
                <Toast ref={this.toast} position="bottom-right" />

                <div>
                    <h5 className="title-notificacoes">
                        Notificações
                    </h5>
                </div>
                <p className="notifications-description">
                    Selecione as cidades que gostaria de receber notificações de encerramento do período.
                </p>

                <input
                    type="text"
                    className="notifications-filter-input"
                    placeholder="Filtrar cidades..."
                    value={filter}
                    onChange={(e) => this.setState({ filter: e.target.value })}
                />

                <div className="notifications-city-list">
                    {filteredCities.map(city => {
                        const label = MONITORING_LABELS[city.follow_up_period] || city.follow_up_period;
                        const isChecked = selectedCityIds.has(city.id);

                        return (
                            <div key={city.id} className="notifications-city-item">
                                <span className="notifications-city-label">
                                    {city.city} - {city.state} |<span style={{ color: '#5B595B' }}> {label}</span>
                                </span>
                                <InputSwitch
                                    checked={isChecked}
                                    onChange={(e) => this.handleToggle(city.id, e.value)}
                                />
                            </div>
                        );
                    })}
                </div>

                <div className="notifications-footer">
                    <button
                        type="button"
                        onClick={this.handleSave}
                        disabled={saving}
                        className="btn background-brain btn-save"
                    >
                        {saving ? 'SALVANDO...' : 'SALVAR'}
                    </button>
                </div>
            </div>
        );
    }
}

export default NotificationsPanel;
